import React from "react";

// Reactstrap components
import { Button, Row, Col, Modal, ModalHeader, ModalBody, Collapse, Card, CardBody, CustomInput, ModalFooter } from "reactstrap";

// style
import "assets/css/default.css";

export default function SetupVisualizacao(props) {
    const {
        modal,
        toggleModalSetup,
        setup,
        groupIsOpen,
        painelsChecked,
        handleChangeGrupo,
        handleChangePainel,
        handleConfirmaSetup
    } = props;

    const verifyGroupIsOpen = (grupo) => {
        if (groupIsOpen.length > 0) {
            return groupIsOpen.filter(x => x.groupName == grupo)[0].isOpen;
        }
        else if (groupIsOpen.length == 0){
            return true;
        }
    }

    const verifyPainelIsChecked = (group, painel) => {
        if (painelsChecked.length > 0) {
            return painelsChecked.filter(x => x.groupName == group && x.painelName == painel)[0].isChecked;
        }
        else if (painelsChecked.length == 0){
            return true;
        }
    }

    return (
        <>
            {setup != null &&
                <Modal isOpen={modal} centered toggle={toggleModalSetup} zIndex="9999999">
                    <ModalHeader
                        toggle={toggleModalSetup}
                        close={<button className="close" onClick={toggleModalSetup}>&times;</button>}
                        className="md-hd"><i className="fas fa-filter"></i> Setup Dasboard
                    </ModalHeader>
                    <ModalBody className="md-bd">
                        {setup.grupos != null && setup.grupos.length > 0 && setup.grupos.map((item, key) => (
                            <Row key={key}>
                                <Col md="12" xs="12">
                                    <Card>
                                        <CardBody className="tituloSetup">
                                            <CustomInput
                                                type="switch"
                                                id={item}
                                                name="switchGrupo"
                                                label={item}
                                                checked={verifyGroupIsOpen(item)}
                                                onChange={(event) => handleChangeGrupo(event.target.checked, item)}
                                            />
                                            <Collapse key={key} isOpen={verifyGroupIsOpen(item)}>
                                                <CardBody>
                                                    {setup.painels.filter(x => x.grupo == item).map((painel, key) => (
                                                        <CustomInput key={key}
                                                            type="switch"
                                                            id={painel.titulo}
                                                            name="switchPainel"
                                                            label={painel.titulo}
                                                            checked={verifyPainelIsChecked(item, painel.titulo)}
                                                            onChange={(event) => handleChangePainel(event.target.checked, item, painel.titulo)}
                                                        />
                                                    ))}
                                                </CardBody>
                                            </Collapse>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        ))}
                    </ModalBody>
                    <ModalFooter className="md-ft">
                        <Row>
                            <Col md="12" xs="12">
                                <Button color="secondary" className="btn-mobile" onClick={toggleModalSetup}>Cancelar</Button>
                                <Button color="success" className="btn-mobile" type="submit" onClick={handleConfirmaSetup}><i className="fas fa-check"></i> Confirmar</Button>
                            </Col>
                        </Row>
                    </ModalFooter>
                </Modal>
            }
        </>
    )
}